<template>
	<div :class="classes">
		<div v-for="( member, index ) in members"
			:key="member.personId"
			class="member-role-picker__row"
		>
			<div><UserAvatar :user="member" /></div>
			<div>{{ member.displayName }}</div>
			<div>
				<TeamRoleDropdown
					v-if="isTeam"
					class-name="member-role-picker__dropdown"
					:disabled="disabled"
					:value="member.role"
					@change="onRoleChange( member.personId, $event.value )"
				/>
				<OneOnOneRoleDropdown
					v-if="isOneOnOne"
					class-name="member-role-picker__dropdown"
					:disabled="disabled"
					:value="member.role"
					@change="onRoleChange( member.personId, $event.value )"
				/>
			</div>
			<slot name="options" :member="member" :members="members" :index="index"></slot>
		</div>
	</div>
</template>

<script>
import { TeamType } from "@teaming/common-enums";
import UserAvatar from "./UserAvatar";
import TeamRoleDropdown from "./TeamRoleDropdown";
import OneOnOneRoleDropdown from "./OneOnOneRoleDropdown";

export default {
	name: "MemberRolePicker",
	emits: [ "change", ],
	components: {
		UserAvatar,
		TeamRoleDropdown,
		OneOnOneRoleDropdown,
	},
	props: {
		className: {
			type: String,
			default: "",
		},
		members: {
			type: Array,
			required: true,
		},
		teamType: {
			type: String,
			default: "TEAM",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		classes() {
			return `member-role-picker ${ this.className }`;
		},
		isTeam() {
			return this.teamType === TeamType.TEAM;
		},
		isOneOnOne() {
			return this.teamType === TeamType.ONE_ON_ONE;
		},
	},
	methods: {
		onRoleChange( personId, role ) {
			this.$emit( "change", { personId, role, } );
		},
	},
};
</script>

<style lang="scss" scoped>
.member-role-picker {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 0.5rem;
}

.member-role-picker__row {
	display: flex;
	flex-direction: row;
	justify-content: space-evenly;
	align-items: center;
	gap: 1rem;

	// name column
	div:nth-child(2) {
		flex: 3;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
}

.member-role-picker__dropdown {
	min-width: 6.875rem;
}
</style>
